<template>
  <component :is="currentComponent" v-bind="currentProps"></component>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InvoiceDetails from '../../components/client/enterRebateItems/InvoiceDetails'
import ItemSearch from '../../components/client/enterRebateItems/ItemSearch'
import ItemSearchResults from '../../components/client/enterRebateItems/ItemSearchResults'
import ItemDetails from '../../components/client/enterRebateItems/ItemDetails'
import ItemConfirmation from '../../components/client/enterRebateItems/ItemConfirmation'
import InvoiceEmail from '../../components/client/enterRebateItems/InvoiceEmail'

export default {
  name: 'EnterRebateItems',
  data () {
    return {
      currentComponent: 'invoice-details',
      compProps: {
        invoiceData: {
          dateOfPurchase: '',
          receiptNumber: '',
          image: {
            url: null,
            fileName: null,
            randomString: null,
            imageKey: null
          },
          items: []
        }
      }
    }
  },
  created () {
    this.$bus.on('swapComponent', this.swapComponent)
  },
  beforeDestroy () {
    this.$bus.off('swapComponent', this.swapComponent)
  },
  mounted () {
    this.$bus.emit('global-load', { load: true, message: 'Loading Rebate Items', env: 'client' })
    this.getLoyaltyProgramBySlug(this.$store.state.slug)
      .then(() => {
        // this.currentComponent = this.initCurrentComponent()
        this.$bus.emit('global-load', { load: false })
      })
      .catch((err) => {
        this.$router.push({ name: 'ClientDashboard' })
        this.$bus.emit('global-load', { load: false })
        console.log(err)
      })
  },
  components: {
    'invoice-details': InvoiceDetails,
    'item-search': ItemSearch,
    'item-search-results': ItemSearchResults,
    'item-details': ItemDetails,
    'item-confirmation': ItemConfirmation,
    'invoice-email': InvoiceEmail
  },
  computed: {
    currentProps () {
      let props = {}
      Object.keys(this.compProps).forEach(key => {
        props[key] = this.compProps[key]
      })
      return props
    },
    ...mapState('loyaltyProgram', {
      fields: state => state.program.rebateItemFields
    }),
    searchableFields () {
      return this.fields.filter(field => field.searchable)
    }
  },
  methods: {
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ]),
    swapComponent (component) {
      if (component.component === 'item-search' && !this.searchableFields.length) {
        this.currentComponent = 'item-search-results'
      } else {
        this.currentComponent = component.component
      }
      if (component.props) {
        this.compProps = { ...component.props, ...{ invoiceData: this.compProps.invoiceData } }
      }
    }
  }
}
</script>
